import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));

// Tied to the CSS (SCSS) piece of code for fixing address bar vh offset
// Both JS and CSS pieces of code needed for it to work
let vh = window.innerHeight * 0.01;
let isVhChanging = false;
document.documentElement.style.setProperty('--vhSize', `${vh}px`);

window.addEventListener('resize', () => {
	vh = window.innerHeight * 0.01;

	if (!isVhChanging) {
		setTimeout(() => {
			isVhChanging = false;
			document.documentElement.style.setProperty('--vhSize', `${vh}px`);
		}, 20);
	}

	isVhChanging = true;
});
